var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.199,
    height: 31.199,
    viewBox: "0 0 31.199 31.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "q_a-icon",
    "data-name": "q&a-icon",
    transform: "translate(-28 -804.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-chat-bubble",
    "data-name": "Icon material-chat-bubble",
    d: "M31.079,3H6.12A3.129,3.129,0,0,0,3,6.12V34.2l6.24-6.24h21.84a3.129,3.129,0,0,0,3.12-3.12V6.12A3.129,3.129,0,0,0,31.079,3Z",
    transform: "translate(25 801.52)",
    fill: "#fbf8fd"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "?",
    transform: "translate(38.706 822.706)",
    fill: "#3aac60",
    fontSize: 17,
    fontFamily: "Montserrat-Black, Montserrat",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQaIcon);
export default __webpack_public_path__ + "static/media/q&a-icon.64d12e6ba8903d97323651d445f6424d.svg";
export { ForwardRef as ReactComponent };